import { Grid, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import ActiveUsersChart from '../components/Analytics/ActiveUsersChart'
import AgentFilterSelect from '../components/Analytics/AgentFilterSelect'
import AnalyticsLayout from '../components/Analytics/AnalyticsLayout'
import ConversationsChart from '../components/Analytics/ConversationsChart'
import FeedbackDonutChart from '../components/Analytics/FeedbackDonutChart'
import MessagesChart from '../components/Analytics/MessagesChart'
import NegativeFeedbackTable from '../components/Analytics/NegativeFeedbackTable'
import RoutingSection from '../components/Analytics/RoutingSection'
import { Feature } from '../core/client/features.gen'
import { useFeature } from '../core/features/FeaturesProvider'
import { AgentFilter } from '../types/analyticsTypes'

const AnalyticsPage: React.FC = () => {
  const [agentId, setAgentId] = useState<AgentFilter>(null)
  const agentRouting = useFeature(Feature.AGENT_ROUTING)

  return (
    <AnalyticsLayout headerAction={<AgentFilterSelect value={agentId} onChange={setAgentId} />}>
      <VStack align='stretch' spacing={6}>
        <Grid templateColumns={{ base: '1fr', lg: '1fr 1fr' }} gap={6}>
          <FeedbackDonutChart agentId={agentId} />
          <ActiveUsersChart agentId={agentId} />
          <ConversationsChart agentId={agentId} />
          <MessagesChart agentId={agentId} />
        </Grid>
        {agentRouting && <RoutingSection agentId={agentId} />}
        <NegativeFeedbackTable agentId={agentId} />
      </VStack>
    </AnalyticsLayout>
  )
}

export default AnalyticsPage
